
$(document).ready(function() {
    $('.carousel').carousel({
        interval: 10000
    })
});
